import { IAvailableStore, IStore } from 'appointment-tool/types';

export function formatStores(stores: IStore[]): IAvailableStore[] {
    return stores.map((store) => {
        const {
            u_smd_storenumber,
            u_smd_lat,
            u_smd_lon,
            u_smd_address,
            u_smd_addressnumber,
            u_smd_city,
            u_smd_sapnr,
        } = store;

        return {
            id: u_smd_storenumber,
            globalId: u_smd_sapnr,
            lat: parseFloat(u_smd_lat),
            lng: parseFloat(u_smd_lon),
            address: `${u_smd_address} ${u_smd_addressnumber}`,
            city: u_smd_city,
        };
    });
}
